export default __webpack_public_path__ + "static/media/vendor.a6d6f1dc.svg";